"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const luxon_1 = require("luxon");
const DateStepPicker_1 = __importDefault(require("./components/DateStepPicker"));
const functions_1 = require("./utils/functions");
// styles
require("./rangeDateStepPicker.scss");
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-rangeDateStepPicker",
    startDateLabel: "Start date",
    endDateLabel: "End date",
    dayChangeStep: 1,
    locale: "it",
};
const RangeDateStepPicker = (_a) => {
    var { className, startDateLabel, startDateLabelClassName, endDateLabelClassName, dates, endDateLabel, locale, minMonthDiffNumber, dayChangeStep, monthsToExclude, minDate, onChangeStartDate, onChangeEndDate, onDatesChange } = _a, rest = __rest(_a, ["className", "startDateLabel", "startDateLabelClassName", "endDateLabelClassName", "dates", "endDateLabel", "locale", "minMonthDiffNumber", "dayChangeStep", "monthsToExclude", "minDate", "onChangeStartDate", "onChangeEndDate", "onDatesChange"]);
    luxon_1.Settings.defaultLocale = locale || "it";
    const classList = (0, classnames_1.default)("tecma-rangeDateStepPicker", className);
    const [dateDisabledArrows, setDateDisabledArrows] = react_1.default.useState(() => {
        if (minDate) {
            return (0, functions_1.getDisabledArrow)(dates, minDate, minMonthDiffNumber, dayChangeStep);
        }
        return null;
    });
    (0, react_1.useEffect)(() => {
        if (minDate) {
            const disabledArrows = (0, functions_1.getDisabledArrow)(dates, minDate, minMonthDiffNumber, dayChangeStep);
            setDateDisabledArrows(disabledArrows);
        }
    }, [dates]);
    const handleChangeDate = (type, direction, dateType) => {
        const newDate = (0, functions_1.getNextDate)(dateType === "startDate" ? dates[0] : dates[1], direction, type, dayChangeStep || 1, monthsToExclude);
        const newDatesValues = dateType === "startDate"
            ? (0, functions_1.getNewDatesFromUpdateStartDate)(dates, newDate, direction, minMonthDiffNumber)
            : (0, functions_1.getNewDatesFromUpdateEndDate)(dates, newDate, direction, minMonthDiffNumber);
        onDatesChange(newDatesValues);
    };
    const handleOnChangeStartDate = (type, direction) => {
        handleChangeDate(type, direction, "startDate");
    };
    const handleOnChangeEndDate = (type, direction) => {
        handleChangeDate(type, direction, "endDate");
    };
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classList }, rest, { children: [(0, jsx_runtime_1.jsx)(DateStepPicker_1.default, { "data-testid": "tecma-startDateStepPicker", onChangeDate: handleOnChangeStartDate, labelClassName: startDateLabelClassName, date: luxon_1.DateTime.fromJSDate(dates[0]), disabledArrow: dateDisabledArrows === null || dateDisabledArrows === void 0 ? void 0 : dateDisabledArrows[0], label: startDateLabel }), (0, jsx_runtime_1.jsx)(DateStepPicker_1.default, { "data-testid": "tecma-endDateStepPicker", onChangeDate: handleOnChangeEndDate, labelClassName: endDateLabelClassName, date: luxon_1.DateTime.fromJSDate(dates[1]), disabledArrow: dateDisabledArrows === null || dateDisabledArrows === void 0 ? void 0 : dateDisabledArrows[1], label: endDateLabel })] })));
};
RangeDateStepPicker.defaultProps = defaultProps;
exports.default = RangeDateStepPicker;
